import { pxToRem } from "@getbread/dough";
import { styled } from "@mui/material/styles";
import { useIntl } from "react-intl";
import { Link } from "react-router";
import breadLogo from "../../assets/bread/en-us/breadLogo.svg";
import { useLocale } from "../LocaleProvider";

const LogoImg = styled("img")`
	max-width: ${pxToRem(220)};
`;

export const Logo = styled(({ className }: { className?: string }) => {
	const intl = useIntl();
	const { locale } = useLocale();
	const altText = intl.formatMessage({ defaultMessage: "Bread Financial Logo" });

	return (
		<Link to="/" className={className} data-testid="header-logo-link">
			<LogoImg src={breadLogo} alt={altText} data-testid={`logo-${locale}`} />
		</Link>
	);
})`
	grid-column: 1/4;
`;
